import { render, staticRenderFns } from "./bankList.vue?vue&type=template&id=573136c8&scoped=true&lang=html"
import script from "./bankList.vue?vue&type=script&lang=js"
export * from "./bankList.vue?vue&type=script&lang=js"
import style0 from "./bankList.vue?vue&type=style&index=0&id=573136c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573136c8",
  null
  
)

export default component.exports